import { Add01Icon, PencilEdit02Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Divider,
  Stack,
  TextField,
  ToggleButtonGroup,
  ToggleButton,
} from '@mui/material';
import { useNode } from '@craftjs/core';
import Frame from '@/components/Frame';
import { MenuItems, MenuItem } from '@/components/menu/Menu';
import { OrganizationProvider } from '@/features/websites/components/OrganizationProvider';

export interface MenuItemsProps extends MenuItems {
  useCustomNavigation?: boolean;
}

enum MenuView {
  DEFINED = 'Definido',
  CUSTOM = 'Personalizado',
}

const MenuSettings = () => {
  const {
    props,
    actions: { setProp },
  } = useNode((node) => ({
    props: node.data.props,
  }));

  const [menuView, setMenuView] = useState<MenuView>(MenuView.DEFINED);

  const { id, activeWebsite } = useContext(OrganizationProvider);

  const handleMenuViewer = (_e: any, value: MenuView) => {
    setMenuView(value);
    setProp((props: MenuItemsProps) => {
      props.useCustomNavigation = value === MenuView.CUSTOM;
      return props;
    });
  };

  return (
    <Stack spacing={2}>
      <Divider>Navegación sitio web</Divider>

      <ToggleButtonGroup
        exclusive
        fullWidth
        size="small"
        color="primary"
        value={menuView}
        onChange={handleMenuViewer}
      >
        <ToggleButton value={MenuView.DEFINED}>Definidos</ToggleButton>
        <ToggleButton value={MenuView.CUSTOM}>Personalizar</ToggleButton>
      </ToggleButtonGroup>

      {menuView === MenuView.CUSTOM ? (
        <>
          {props.menuItems?.map((_menuItem: MenuItem, index: number) => (
            <Frame key={`${index}`}>
              <Stack spacing={2}>
                <TextField
                  name="title"
                  label="Tītulo"
                  size="small"
                  value={props?.menuItems[index].label ?? ''}
                  onChange={(e) => {
                    const menu = [...(props?.menuItems ?? [])];
                    menu.splice(index, 1, {
                      ...menu[index],
                      label: e.target.value,
                    });
                    setProp(
                      (props: MenuItemsProps) => (props.menuItems = menu)
                    );
                  }}
                />

                <TextField
                  name="url"
                  label="URL"
                  size="small"
                  value={props?.menuItems[index].url ?? ''}
                  onChange={(e) => {
                    const menu = [...(props?.menuItems ?? [])];
                    menu.splice(index, 1, {
                      ...menu[index],
                      url: e.target.value,
                    });
                    setProp(
                      (props: MenuItemsProps) => (props.menuItems = menu)
                    );
                  }}
                />
              </Stack>
            </Frame>
          ))}

          <Button
            startIcon={<HugeiconsIcon icon={Add01Icon} />}
            onClick={() => {
              const menu = [...(props?.menuItems ?? [])];
              menu.push({
                label: 'Test',
                url: '/',
              });
              setProp((props: MenuItemsProps) => (props.menuItems = menu));
            }}
          >
            Agregar
          </Button>
        </>
      ) : (
        <>
          <Button
            component={Link}
            to={`/comercios/${id}/websites`}
            startIcon={activeWebsite?.menu?.length ? <HugeiconsIcon icon={PencilEdit02Icon} /> : <HugeiconsIcon icon={Add01Icon} />}
            target="_blank"
          >
            {activeWebsite?.menu?.length ? 'Editar' : 'Crear'}
          </Button>
        </>
      )}
    </Stack>
  );
};

export default MenuSettings;
